import { render, staticRenderFns } from "./FreeSignupPinsReport.vue?vue&type=template&id=74a35ba6&scoped=true"
import script from "./FreeSignupPinsReport.vue?vue&type=script&lang=js"
export * from "./FreeSignupPinsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a35ba6",
  null
  
)

export default component.exports